import { __awaiter } from "tslib";
import { RcsbFvAbstractModule } from "./RcsbFvAbstractModule";
import { PairwiseAlignmentBuilder } from "../../RcsbUtils/PairwiseAlignmentTools/PairwiseAlignmentBuilder";
import { Assertions } from "../../RcsbUtils/Helpers/Assertions";
var assertDefined = Assertions.assertDefined;
export class RcsbFvPairwiseAlignment extends RcsbFvAbstractModule {
    protectedBuild() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const buildConfig = this.buildConfig;
            assertDefined(buildConfig.psa);
            const pab = new PairwiseAlignmentBuilder(buildConfig.psa);
            const config = Object.assign({ rowTitleWidth: 120, length: pab.getLength(), includeAxis: !buildConfig.psa.pairwiseView }, (_a = buildConfig.additionalConfig) === null || _a === void 0 ? void 0 : _a.boardConfig);
            this.boardConfigData = Object.assign(Object.assign({}, this.boardConfigData), config);
            this.rowConfigData = buildConfig.psa.pairwiseView ? pab.buildPairwiseAlignment() : pab.buildReferenceAlignment();
            return void 0;
        });
    }
    concatAlignmentAndAnnotationTracks() {
    }
}
//# sourceMappingURL=RcsbFvPairwiseAlignment.js.map